import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './uiRadio.sass'

const UIRadio = props => {
  const radioId = `ui-radio-${props.name}-${props.value}`

  return (
    <label
      htmlFor={radioId}
      className={classNames('ui-radio', props.className, { '--big': props.isBig })}
    >
      <input
        className="ui-radio__radio"
        id={radioId}
        name={props.name}
        value={props.value}
        checked={props.checked}
        onChange={props.onChange}
        type="radio"
      />
      <span className="ui-radio__input" />
      {props.children}
    </label>
  )
}

UIRadio.defaultProps = {
  value: null,
  className: '',
  isBig: false,
  children: null,
}

UIRadio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.node,
  checked: PropTypes.bool.isRequired,
  isBig: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default UIRadio
